module.exports = __webpack_public_path__ + "img/banner-home.641d6c4a.jpg";